import React from "react";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { StaticKv } from "../components/StaticKv";
import "../assets/styles/privacy.scss";

export const Privacy = () => {
  const isSp = window.innerWidth < 769;
  return (
    <div className="page-privacy">
      <Header>
        <StaticKv title={isSp ? "privacy-sp" : "privacy"} />
      </Header>
      <div className="privacy-main">
        <h3>プライバシーポリシー</h3>
        <h4 className="text">
          ドリミット株式会社（以下、弊社といいます。）は、個人情報の保護は弊社が事業活動を行うにあたっての基礎であるとともに、弊社の社会的責任であると認識しております。
          <br />
          弊社は、弊社の製品やサービスに関する情報をはじめ、お客様からご提供いただいた個人情報等、多種多様な情報を取り扱っております。
          <br />
          弊社は個人情報保護について、関連規程の制定及び管理体制の確立を図るとともに、以下のとおりプライバシーポリシーを定め、弊社役員及び従業員に周知徹底し、本方針に従って個人情報を適切に利用、管理及び保護することといたします。
        </h4>
        <p className="title">1. 個人情報の収集、利用及び提供について</p>
        <p className="text">
          弊社は、事業活動を行うにあたって、お客様の大切な情報をご提供いただいていることを踏まえ、各業務実態に応じて個人情報を保護するための情報管理体制を確立し、個人情報の収集、利用及び提供に関して所定の規程に則り適切な取り扱いをいたします。
        </p>
        <p className="title">2. 法令の遵守について</p>
        <p className="text">
          弊社は、個人情報の取り扱いに関して、法令を遵守いたします。
        </p>
        <p className="title">3. 安全対策について</p>
        <p className="text">
          弊社は、個人情報を保護するため、情報セキュリティに関する規程に基づき、当該個人情報の管理、個人情報の持ち出し方法の指定、第三者からの不正アクセスの防止等の対策を行い、個人情報の漏洩、紛失、改ざん、破壊等の予防を図ります。
        </p>
        <p className="title">4. ご本人様の要請について</p>
        <p className="text">
          弊社は、個人情報に関して、ご本人様から当該個人情報の開示、訂正、削除、利用または提供について何らかの要請を受けた場合、誠実に対応いたします。
        </p>
        <p className="title">5. 個人情報管理規程について</p>
        <p className="text">
          弊社は、弊社役員及び従業員に対し、個人情報を保護する重要性と必要性の理解促進を図り、個人情報の適切な管理を図るため、個人情報管理規程を定め、当該規程を遵守いたします。
        </p>
        <p className="title">個人情報の利用目的</p>
        <p className="text">
          弊社は、事業活動に関連してご提供いただく（またはご提供いただいている）個人情報に関して、以下の目的に該当する場合のみ利用いたします。
        </p>
        <p className="title">１. お客様の個人情報について</p>
        <p className="text">
          弊社製品及びサービス情報等に関するご案内のため
          <br />
          弊社製品及びサービス情報等についてのお問い合わせに対する回答連絡のため
          <br />
          弊社製品及びサービス情報等についてのアフターサービスなど取引業務遂行のため
          <br />
          弊社製品及びサービスの販売またはご提供を目的とするご本人様確認のため
          <br />
          弊社製品及びサービス情報等についてのアンケート調査及びモニター調査のため
          <br />
          弊社製品及びサービス情報等についてのマーケティング活動のため
          <br />
          その他弊社製品及びサービス情報等のご提供に必要な場合
        </p>
        <p className="title">２. 株主及び投資家の方の個人情報について</p>
        <p className="text">
          法令に基づく権利行使及び義務履行のため
          <br />
          法令に基づく株主管理のため
          <br />
          IR活動について株主及び投資家の皆様への情報提供及び調査のため
        </p>
        <p className="title">３. 取引先各社の個人情報について</p>
        <p className="text">業務上必要な諸連絡及び商談等のため</p>
        <p className="title">４. 採用応募者様の個人情報について</p>
        <p className="text">採用活動についての連絡、情報提供及び調査のため</p>
        <p className="title">５. 広報活動にあたっての個人情報について</p>
        <p className="text">広報活動としての情報提供のため</p>
        <p className="title">６. 環境保全活動にあたっての個人情報について</p>
        <p className="text">
          CSR・環境保全活動についての情報提供及びアンケート調査のため
        </p>
        <p className="title">お問い合わせ窓口</p>
        <p className="text">
          弊社が現在保有する個人情報についての開示等の要請及び弊社の個人情報の取り扱いにつ
          いてのご質問は、以下の手続きにて承っております。
          <br />
          なお、本手続きによらない要請の場合、ご対応いたしかねる場合がございますので、ご了
          承ください。
        </p>
        <p className="title">１. 個人情報の開示等の手続き</p>
        <p className="text">
          下記の送付先まで、郵送にてお送りください。
          <br />
          弊社からご本人様またはその代理人様であることのご確認をさせていただき、確認が取れ
          次第、書面のご送付またはお客様及び弊社が合意した方法にてご対応いたします。
          なお、郵送料はご本人様のご負担となること、対応には日数を頂戴することにつきご了承
          ください。
        </p>
        <p className="title">２. 送付先</p>
        <p className="text">
          〒101-0021
          <br />
          東京都千代田区外神田5丁目1-12 武廣ビル2階
          <br />
          ドリミット株式会社
          <br />
          電話番号：03-5817-4752
          <br />
          受付時間：平日午前10時から午後19時まで
        </p>
      </div>
      <Footer />
    </div>
  );
};
